import { CreateAxiosDefaults } from 'axios';
import getConfig from 'next/config';
import { getLocale } from '../i18n';

const { NEXT_PUBLIC_API_URL = process.env.API_URL } = getConfig().publicRuntimeConfig;

const locale = getLocale();
const apiConfig: CreateAxiosDefaults = {
  baseURL: `${NEXT_PUBLIC_API_URL}/${locale !== 'en-us' ? locale : ''}/`,
  withCredentials: true,
};

export default apiConfig;
